export default "__VITE_ASSET__hoPGhUa$__"